<template>
  <div>
    <el-table
      :border="true"
      id="rebateSetTable"
      :data="tableData"
      ref="table"
      show-summary
      :max-height="tableHeight"
      v-loading="loading"
      @sort-change="handlerSortChange"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-table-column
        v-for="item in columns"
        :prop="item.key"
        :label="item.name"
        :key="item.name"
        :sortable="item.sort ? 'custom' : false"
        :fixed="item.fixed"
        align="center"
        :width="item.width"
      >
        <el-table-column
          :prop="item.key"
          :label="totalObj[item.key] ? totalObj[item.key] + '' : ''"
          :width="
            item.key == 'totalIncre' ||
            item.key == 'incomeTotalUSD' ||
            item.key == 'popTotalUSD'
              ? 200
              : item.width
          "
          :key="item.name"
          align="center"
        >
          <template slot="header" slot-scope="scope">
            <span
              v-if="item.key == 'totalIncre'"
              style="display: flex; text-align: left"
            >
              <span style="flex: 1">{{ totalObj[item.key] || "" }} </span>
              <span
                v-if="totalObj.totalIncre && totalObj.totalIncre != 0"
                :style="{
                  color:
                    Number(totalObj.totalIncre) < Number(totalObj[item.key])
                      ? 'rgba(249, 29, 29, 1)'
                      : 'rgba(16, 204, 102, 1) ',
                  flex: 1,
                }"
              >
                {{
                  totalObj.totalIncre && totalObj.totalIncre != 0
                    ? (
                        (Math.abs(
                          Number(totalObj[item.key]) -
                            Number(totalObj.totalIncre)
                        ) *
                          100) /
                        Number(totalObj.totalIncre)
                      ).toFixed(2) + "%"
                    : "-"
                }}
                <svg-icon
                  v-if="totalObj.totalIncre < totalObj[item.key]"
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon>
              </span>
              <span v-else style="flex: 1">--</span>
            </span>
            <span
              v-else-if="item.key == 'incomeTotalUSD'"
              style="display: flex; text-align: left"
            >
              <span style="flex: 1">{{ totalObj[item.key] || "" }} </span>
              <span
                :style="{
                  color:
                    Number(totalObj.totalIncome) <
                    Number(totalObj[item.key] ? totalObj[item.key] : 0)
                      ? 'rgba(249, 29, 29, 1)'
                      : 'rgba(16, 204, 102, 1) ',
                  flex: 1,
                }"
              >
                {{
                  totalObj[item.key] && totalObj.totalIncome
                    ? (
                        Math.abs(
                          (Number(totalObj[item.key].split("$")[1]) -
                            totalObj.totalIncome) *
                            100
                        ) / totalObj.totalIncome
                      ).toFixed(2) + "%"
                    : "-"
                }}

                <svg-icon
                  v-if="
                    Number(totalObj.totalIncome) <
                    Number(totalObj[item.key] ? totalObj[item.key] : 0)
                  "
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon>
              </span>
            </span>
            <span
              v-else-if="item.key == 'popTotalUSD'"
              style="display: flex; text-align: left"
            >
              <span style="flex: 1">{{ totalObj[item.key] || "" }} </span>
              <span
                v-if="totalObj.totalPopu != 0"
                :style="{
                  color:
                    totalObj.totalPopu <
                    Number(
                      totalObj[item.key] ? totalObj[item.key].split('$')[1] : 0
                    )
                      ? 'rgba(249, 29, 29, 1)'
                      : 'rgba(16, 204, 102, 1) ',
                  flex: 1,
                }"
              >
                {{
                  totalObj[item.key] && totalObj.totalPopu
                    ? (
                        Math.abs(
                          (Number(totalObj[item.key].split("$")[1]) -
                            totalObj.totalPopu) *
                            100
                        ) / totalObj.totalPopu
                      ).toFixed(2) + "%"
                    : "-"
                }}
                <svg-icon
                  v-if="
                    totalObj.totalPopu <
                    Number(
                      totalObj[item.key] ? totalObj[item.key].split('$')[1] : 0
                    )
                  "
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon>
              </span>
              <span v-else style="flex: 1">--</span>
            </span>
            <span v-else @click="handleS(scope)">{{
              totalObj[item.key] ? totalObj[item.key] + "" : ""
            }}</span>
          </template>
          <template slot-scope="scope">
            <span v-if="item.key == 'totalIncre'" class="zidingyi">
              <span class="zidingyileft">{{ scope.row.totalIncre }}</span>
              <span
                class="zidingyiright"
                :class="{
                  isGreen:
                    scope.row['totalIncreDiffer'] &&
                    scope.row['totalIncreDiffer'] < 0,
                  isRed:
                    scope.row['totalIncreDiffer'] &&
                    scope.row['totalIncreDiffer'] > 0,
                }"
              >
                {{
                  scope.row["totalIncreDiffer"]
                    ? `${Math.abs(scope.row["totalIncreDiffer"])}%`
                    : "-"
                }}

                <span
                  v-if="!scope.row['totalIncreDiffer']"
                  iconClass="up"
                ></span>
                <svg-icon
                  v-else-if="scope.row['totalIncreDiffer'] > 0"
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon> </span
            ></span>
            <span v-else-if="item.key == 'incomeTotalUSD'" class="zidingyi">
              <span class="zidingyileft">{{ scope.row.incomeTotalUSD }}</span>
              <span
                class="zidingyiright"
                :class="{
                  isGreen:
                    scope.row['totalIncomeDiffer'] &&
                    scope.row['totalIncomeDiffer'] < 0,
                  isRed:
                    scope.row['totalIncomeDiffer'] &&
                    scope.row['totalIncomeDiffer'] > 0,
                }"
              >
                {{
                  scope.row["totalIncomeDiffer"]
                    ? `${Math.abs(scope.row["totalIncomeDiffer"])}%`
                    : "-"
                }}
                <span
                  v-if="!scope.row['totalIncomeDiffer']"
                  iconClass="up"
                ></span>
                <svg-icon
                  v-else-if="scope.row['totalIncomeDiffer'] > 0"
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon> </span
            ></span>
            <span v-else-if="item.key == 'popTotalUSD'" class="zidingyi">
              <span class="zidingyileft">{{ scope.row.popTotalUSD }}</span>
              <span
                class="zidingyiright"
                :class="{
                  isGreen:
                    scope.row['totalPopuDiffer'] &&
                    scope.row['totalPopuDiffer'] < 0,
                  isRed:
                    scope.row['totalPopuDiffer'] &&
                    scope.row['totalPopuDiffer'] > 0,
                }"
              >
                {{
                  scope.row["totalPopuDiffer"]
                    ? `${Math.abs(scope.row["totalPopuDiffer"])}%`
                    : "-"
                }}
                <span
                  v-if="!scope.row['totalPopuDiffer']"
                  iconClass="up"
                ></span>
                <svg-icon
                  v-else-if="scope.row['totalPopuDiffer'] > 0"
                  iconClass="up"
                ></svg-icon>
                <svg-icon v-else iconClass="down"></svg-icon> </span
            ></span>
            <span v-else-if="item.key === 'lineCharts'">
              <div @click="openChartMoal(scope.row.incres || [], scope.row)">
                <cell-charts :dataList="scope.row.incres || []"></cell-charts>
              </div>
            </span>
            <span v-else>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="page-wrap">
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changeSize"
      ></self-pagination>
    </div>
  </div>
</template>

<script>
import { downLoadWrokSheet } from "@/utils/commonTools";
import SvgIcon from "../../components/SvgIcon.vue";
import CellCharts from "./cellChart.vue";
import { columns, osTypeFu } from "./config";
import { getAllReportListFetch } from "@/api/api";

export default {
  data() {
    return {
      columns,
      tableHeight: window.innerHeight - 270,
      tableData: [],
      totalObj: {},
      loading: false,
      filterParams: {},
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      sortInfo: {
        sortField: "",
        sortValue: null,
      },
    };
  },
  computed: {},
  components: { SvgIcon, CellCharts },
  props: {},
  methods: {
    handleSearch(filterParams) {
      this.filterParams = filterParams;
      this.pageData.page = 1;
      this.getList();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changeSize(size) {
      this.pageData.size = size;
      this.getList();
    },
    handlerSortChange(data) {
      const { prop, order } = data;
      this.sortInfo = {
        sortField: prop,
        sortValue: order == null ? null : order == "descending" ? 1 : 2,
      };
      this.getList();
    },
    getList() {
      this.loading = true;
      getAllReportListFetch({
        ...this.filterParams,
        page: this.pageData.page,
        size: this.pageData.size,
        ...this.sortInfo,
      }).then((res) => {
        if (res.code == "0000") {
          this.pageData.total = res.totalCount;
          this.tableData = res.totalPart.map((v) => {
            return this.transformData(v);
          });
          this.totalObj = this.transformData(res.collec);
          this.totalObj.ord = "总计";
          this.totalObj.appName = "--";
          this.totalObj.osType = "--";
          this.totalObj.lineCharts = "--";
        }
        this.loading = false;
      });
    },
    transformData(obj) {
      let item = JSON.parse(JSON.stringify(obj));
      item.osType = osTypeFu(item.osType);
      for (let child in item.collec) {
        item[child] = item.collec[child];
      }
      Object.keys(item).forEach((key) => {
        const findObj = this.columns.find((child) => child.key == key) || {};
        const unitStr =
          (item[key] || item[key] === 0) && findObj.unit ? findObj.unit : "";
        const valueStr = item[key] || item[key] === 0 ? item[key] : "--";
        const percentStr =
          (item[key] || item[key] === 0) && findObj.percent
            ? findObj.percent
            : "";
        item[key] = `${unitStr}${valueStr} ${percentStr}`;
      });
      return item;
    },
    downLoadFileToExcel() {
      getAllReportListFetch({
        ...this.filterParams,
        ...this.sortInfo,
        page: 1,
        size: 99999,
      }).then((res) => {
        if (res.code == "0000") {
          let tableData = JSON.parse(JSON.stringify(res.totalPart));
          let totalObj = JSON.parse(JSON.stringify(res.collec));
          tableData = tableData.map((v) => {
            return this.transformData(v);
          });
          totalObj = this.transformData(totalObj);
          totalObj.ord = "总计";
          totalObj.appName = "--";
          totalObj.osType = "--";
          totalObj.lineCharts = "--";
          const haderData = {};
          const columns = this.columns;
          columns.forEach((item) => {
            haderData[item.key] = item.name;
          });
          this.$emit("closeDownLoadLoading");
          downLoadWrokSheet(
            [totalObj].concat(tableData),
            "自定义报表.xlsx",
            haderData
          );
        }
      });
    },

    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    handleS(scope) {
      console.log(scope);
    },
    openChartMoal(data, row) {
      if (data.length > 0) {
        this.$emit("openModal", data, row);
      }
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}

.isGreen {
  color: rgba(16, 204, 102, 1);
}
.isRed {
  color: rgba(249, 29, 29, 1);
}
.zidingyi {
  width: 100%;
  display: flex;

  .zidingyileft {
    flex: 1;
    text-align: left;
  }
  .zidingyiright {
    flex: 1;
    text-align: left;
    // margin-left: 3px;
  }
}
</style>
